import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type TCityPermissions = number[];

const userPermittedCitiesAtom = atomWithStorage<TCityPermissions | null>(
  'userPermittedCities',
  null,
);
userPermittedCitiesAtom.debugLabel = 'cityPermissions';

export const useUserPermittedCities = () => useAtom(userPermittedCitiesAtom);
